import { Stack, styled } from '@mui/material'
import bgPrincing from '@assets/images/bg_facture_home.png'
export const StackStyled = styled(Stack)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '1rem',
  backgroundImage: `url(${bgPrincing})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  height: '40vh',
  margin: '6rem 0rem',

  [theme.breakpoints.down('sm')]: {
    height: 'max-content',

    padding: '2rem',
  },
}))
